import React, { useEffect, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';

import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { useObjCommonFilterStore } from "src/hooks/objCommonFilter";
import { useAdminOrderStore } from "src/hooks/admin/order";
import Helper from "../../../helper/Helper";
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { isArray } from "underscore";
import Constants from "../../../helper/Constants";
import AdminConfig from "@system/config/admin";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";


const OrderAdminList = () => {
  const [{ adminOrderList: { orders, total } }, { get_admin_orders }, { clear_admin_orders }] = useAdminOrderStore();
  const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const [{ filter_list },] = useObjCommonFilterStore();
  const gridRef = React.useRef();
  const [rowData, setRowData] = useState([]);
  const [__check] = useAxiosIndicatorCheck();
  const [, , { reprocess_order }] = useAdminOrderStore();
  const [searched, search] = useState(false);
  const { siteUser } = Constants;
  const [agGridFiltered, setAgGridFiltered] = useState(0);

  const renderOrderId = (e) => {
    const data = e?.data;
    return <a href={`${AdminConfig.getAdminOrderInsightURL()}?OrderId=${data?.OrderId}&SalesOrderNumber=${data?.SalesOrderNumber}&FSPOrderStatus=${data?.FSPOrderStatus}`} target="_blank" rel="noreferrer">{data?.OrderId}</a>
  }

  const renderSalesOrder = (e) => {
    const data = e?.data;
    return <a href={`${AdminConfig.getAdminOrderInsightURL()}?SalesOrderNumber=${data?.SalesOrderNumber}&OrderId=${data?.OrderId}&FSPOrderStatus=${data?.FSPOrderStatus}`} target="_blank" rel="noreferrer">{data?.SalesOrderNumber}</a>
  }

  const renderReprocess = (e) => {
    return e?.data?.IsReprocessable ? <div className='text-center'>
        <i className="fa fa-refresh cursor-pointer font-18 text-green" onClick={(event) => {
          reprocess(e)
        }}></i></div> : null;
  }

  const userIdRenderer = (e) => {
    if (e.data) {
      const userType = e?.data?.AccountNumber ? siteUser?.CORE : siteUser?.WEB;
      return <a href={`${AdminConfig.getUserDetailURL()}?uid=${e.data?.UserId}&userType=${userType}`} target="_blank" rel="noreferrer">{e.data?.CustomerLoginId}</a>
    } else {
      return null;
    }
  }

  const reprocess = async (e) => {
    let data = e?.node?.data;
    __set("ORDER_REPROCESS")
    const res = await reprocess_order({ OrderId: data.OrderId });
    __remove("ORDER_REPROCESS")
    if (res?.isSuccessFull) {
      data = res?.data;
      e?.node?.setData({
        OrderId: data?.orderId,
        IsReprocessable: data?.isReprocessable,
        SalesOrderNumber: data?.salesOrderNumber,
        FSPOrderStatus: data?.fspOrderStatus,
        CreatedOn: Helper.dateFormatFromString(data?.createdOn),
        UpdatedOn: Helper.dateFormatFromString(data?.updatedOn),
        RejectedReason: data?.rejectedReason,
        AccountNumber: data?.accountNumber,
        Buyer: data?.buyer,
        CustomerLoginId: data?.customerLoginId,
        UserId: data?.userId,
      });
      remove_system_alert_indicator("reprocessOrder")
    } else {
      await system_alert_indicator({
        name: "reprocessOrder",
        message: res?.errorMessage,
        type: "danger",
        isDisplay: true,
      });
      data.IsReprocessable = false;
      e?.node?.setData(data);
    }
    e?.api?.refreshCells();
  }

  const [columnDefs] = useState([
    {
      field: 'reprocess',
      headerName: 'REPROCESS',
      headerTooltip: 'REPROCESS',
      maxWidth: 120,
      suppressMovable: true,
      pinned: true,
      sortable: false,
      suppressMenu: true,
      cellRenderer: renderReprocess,
    },
    {
      field: 'OrderId',
      headerName: 'WEB ORDER NUMBER',
      headerTooltip: 'WEB ORDER NUMBER',
      sortable: true,
      minWidth: 130,
      suppressMovable: true,
      pinned: true,
      unSortIcon: true,
      cellRenderer: renderOrderId
    },
    {
      field: 'SalesOrderNumber',
      headerName: 'SALES ORDER NUMBER',
      headerTooltip: 'SALES ORDER NUMBER',
      sortable: true,
      minWidth: 130,
      pinned: true,
      unSortIcon: true,
      cellRenderer: renderSalesOrder
    },
    {
      field: 'FSPOrderStatus',
      headerName: 'FSP ORDER STATE',
      headerTooltip: 'FSP ORDER STATE',
      sortable: true,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'CreatedOn',
      headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'UpdatedOn',
      headerName: 'UPDATED ON',
      headerTooltip: 'UPDATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'RejectedReason',
      headerName: 'REJECT REASON',
      headerTooltip: 'REJECT REASON',
      sortable: true,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'AccountNumber',
      headerName: 'ACCOUNT NUMBER',
      headerTooltip: 'ACCOUNT NUMBER',
      sortable: true,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'Buyer',
      headerName: 'BUYER',
      headerTooltip: 'BUYER',
      sortable: true,
      unSortIcon: true,
      minWidth: 130,
    },
    {
      field: 'CustomerLoginId',
      headerName: 'CUSTOMER LOGIN ID',
      headerTooltip: 'CUSTOMER LOGIN ID',
      sortable: true,
      minWidth: 130,
      unSortIcon: true,
      cellRenderer: userIdRenderer
    },
  ]);

  useEffect(() => {
    if (!isArray(orders)) {
      setRowData([])
      return;
    }
    const data = orders?.map((_order) => {
      return {
        OrderId: _order.orderId,
        IsReprocessable: _order.isReprocessable,
        SalesOrderNumber: _order.salesOrderNumber,
        FSPOrderStatus: _order.fspOrderStatus,
        CreatedOn: Helper.dateFormatFromString(_order.createdOn),
        UpdatedOn: Helper.dateFormatFromString(_order.updatedOn),
        RejectedReason: _order.rejectedReason,
        AccountNumber: _order.accountNumber,
        Buyer: _order.buyer,
        CustomerLoginId: _order.customerLoginId,
        UserId: _order?.userId,
      };
    });
    setRowData(data)
  }, [orders]);

  useEffect(() => {
    const filterArray = Object.entries(filter_list);

    async function fetchHere() {
      if (filterArray.length > 0) {
        __set("ADMIN_ORDER_LIST")
        const params = {
          propertyName: Object.entries(filter_list)?.[0][1].key,
          propertyValue: Object.entries(filter_list)?.[0][1]?.searchKeyword?.trim() || "",
        }
        const res = await get_admin_orders(params);
        if (res?.payload?.ErrorCode === '403') {
            system_alert_indicator({
              name: "accessDenied",
              message: res?.payload?.Message,
              type: "danger",
              isDisplay: false,
              isDisplayIcon: true
          });
          }
        __remove("ADMIN_ORDER_LIST")
        search(true);
      } else {
        search(false);
        await clear_admin_orders();
      }
    }

    fetchHere();
  }, [filter_list]);

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    // setGridColumnApi(params.columnApi);
  }

  return (
    <>
      {rowData.length > 0 &&
        <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
          <div className="d-flex justify-content-start">
            Filtered Line Count: <b>{agGridFiltered}</b>
          </div>
          <div className="d-flex justify-content-end">
            Total Records: <b>{total}</b>
          </div>
        </div>}
      {/* <div className='bg-black p-2 minh50'></div> */}
      {searched && (__check("ADMIN_ORDER_LIST").status ? __check("ADMIN_ORDER_LIST").render :
        (orders?.length > 0 ?
          <div className="ag-theme-alpine ag-grd-hg mb-5 order-admin-list">
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              columnDefs={columnDefs}
              suppressRowClickSelection={true}
              onGridReady={onGridReady}
              defaultColDef={{
                flex: 1,
                sortable: true,
                filter: true,
                enableRowGroup: true,
                enableValue: true,
                lockPinned: true,
                resizable: true
              }}
              autoGroupColumnDef={{
                headerName: 'Group',
                minWidth: 220,
              }}
            >
            </AgGridReact>
          </div> :
          <div className='container mt-4'>
            <NoResultContent
              message={`Sorry! No Result Found. We can't find any results based on your selection.`}
              isDisplay={false}/></div>))}
    </>
  );
}
export default OrderAdminList;